import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../../services/http.service";

const DASHBOARD = `/dashboard`;
const NON_REAL_DASHBOARD = `/non-real/dashbaord`;

// CPA Dashboard
export const getCpaDashoard = createAsyncThunk(
  "getCpaDashoard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { owner_uuid = "" } = values;
      const response = await http.get(`${DASHBOARD}?owner_uuid=${owner_uuid}`);      
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Spouse dashboard
export const getSpouseDashoard = createAsyncThunk(
  "getSpouseDashoard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${DASHBOARD}`);      
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Non-real dashboard
export const getNonRealDashoard = createAsyncThunk(
  "getNonRealDashoard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${NON_REAL_DASHBOARD}`);      
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Owner dashboard
export const getOwnerDashoard = createAsyncThunk(
  "getOwnerDashoard",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${DASHBOARD}`);      
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);